import { render } from "./vgodownedit.vue?vue&type=template&id=77246c45&scoped=true"
import script from "./vgodownedit.vue?vue&type=script&lang=js"
export * from "./vgodownedit.vue?vue&type=script&lang=js"

import "./vgodownedit.vue?vue&type=style&index=0&id=77246c45&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77246c45"]])

export default __exports__